import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { getActiveReferral } from "../referral";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await axios.post(`${API}/newsletter`, {
                email,
                referral_code: getActiveReferral() || undefined,
            });
            toast.success("You're in. Welcome to the movement.");
            setEmail("");
        } catch (err) {
            const status = err?.response?.status;
            if (status === 409) {
                toast.info("You're already on the movement list.");
            } else {
                toast.error("Couldn't sign you up. Try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    // Marquee text — repeated for seamless loop
    const word = (
        <span className="inline-flex items-center gap-8 px-6">
            <span className="font-display uppercase">Focus</span>
            <span className="text-[#E63946]">●</span>
            <span className="font-display uppercase">Grind</span>
            <span className="text-white/30">●</span>
            <span className="font-display uppercase">Motivate</span>
            <span className="text-[#1D4ED8]">●</span>
        </span>
    );

    return (
        <section
            id="newsletter"
            data-testid="newsletter-section"
            className="relative bg-black py-16 md:py-24 overflow-hidden"
        >
            {/* Background marquee strips */}
            <div className="absolute inset-0 flex flex-col justify-between pointer-events-none opacity-[0.08]">
                <div className="marquee whitespace-nowrap font-outline text-[10rem] md:text-[14rem] leading-none">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <span key={i}>{word}</span>
                    ))}
                </div>
                <div className="marquee marquee-reverse whitespace-nowrap font-outline text-[10rem] md:text-[14rem] leading-none">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <span key={i}>{word}</span>
                    ))}
                </div>
            </div>

            <div className="relative max-w-3xl mx-auto px-6 md:px-10 text-center">
                <div className="flex items-center justify-center gap-4 mb-6">
                    <span className="h-px w-12 bg-[#1D4ED8]" />
                    <span className="font-display tracking-[0.35em] text-zinc-400 text-sm uppercase">
                        / 05 — Join The Movement
                    </span>
                    <span className="h-px w-12 bg-[#E63946]" />
                </div>

                <h2
                    data-testid="newsletter-title"
                    className="font-display uppercase text-white text-5xl md:text-7xl leading-[0.9] tracking-tight mb-6"
                >
                    Be First To <br />
                    <span className="font-outline-strong">Drop</span> With Us
                </h2>

                <p className="text-zinc-400 font-body mb-10 max-w-lg mx-auto">
                    Get early access to releases, ambassador updates, and the stories
                    behind every drop.
                </p>

                <form
                    onSubmit={submit}
                    data-testid="newsletter-form"
                    className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto bg-fgm-surface border border-white/10 p-3"
                >
                    <input
                        data-testid="newsletter-input"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="fgm-input flex-1 border-0 bg-transparent focus:bg-transparent"
                        placeholder="your@email.com"
                    />
                    <button
                        data-testid="newsletter-submit"
                        type="submit"
                        disabled={loading}
                        className="btn-primary !py-4 disabled:opacity-50"
                    >
                        {loading ? "Joining…" : "Join Movement"}
                    </button>
                </form>

                <div className="mt-6 text-xs font-display tracking-[0.3em] text-zinc-600 uppercase">
                    No spam · Drop-day priority · Unsubscribe anytime
                </div>
            </div>
        </section>
    );
}
